export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4762.7cb39e23.jpg";